define('components/course/models/slide-type/half-width',[
    "components/course/models/slide-type/zeus-base",
    "components/course/models/text-image-component"
], function(BaseModel, TextImageComponentModel) {
    "use strict";

    /**
     * Model for Half Width slide
     * @extends BaseModel
     * @class HalfWidthModel
     * @type Object
     * @constructor
     */
    var HalfWidthModel = BaseModel.extend({

        /**
         * Stores the Text Image Component Model
         * @attribute textImageComponentModel
         * @type Object
         * @default null
         */
        "textImageComponentModel": null,

        /**
         * Sets defaults from model
         *
         * @method defaults
         * @private
         * @return {Object} Defaults if not set by user
         */
        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.apply(this, arguments),
                textImageDefaults = {

                    /**
                     * Stores the type of slide
                     * @attribute type
                     * @type String
                     * @default text-image
                     */
                    "type": "half-width",

                    /**
                     * Stores the data required by the slide
                     * @attribute data
                     * @type Object
                     */
                    "data": {

                        /**
                         * Stores the data of text image component
                         * @attribute textImageComponentModelData
                         * @type Object
                         * @default null
                         */
                        "textImageComponentModelData": null,

                        /**
                         * Stores the background Image data
                         * @attribute backgroundImageData
                         * @type Object
                         * @default null
                         */
                        "backgroundImageData": null,

                        /**
                         * Stores the TEI GUID
                         * @attribute teiGUID
                         * @type String
                         * @default null
                         */
                        "teiGUID": null,

                        /**
                         * Stores the rendering side of TEI
                         * @attribute teiSide
                         * @type String
                         * @default left
                         */
                        "teiSide": HalfWidthModel.SIDE.LEFT,
                        "studentResponseScore": 0,
                        "bAddCustomFeedback": false,
                        "sCustomFeedback": "",
                        "userScoreStatus": null,
                        "maxScoreStatus": null,
                        "teiComponentAccText": null,
                        "textImageComponentAccText": null,
                        "saveState": {
                            "studentResponse": {
                                "assessmentGuid": null,
                                "items": []
                            }
                        }
                    }
                };

            return _.extend(baseDefaults, textImageDefaults);
        },

        /**
         * Initializes the model
         *
         * @method initialize
         * @private
         */
        "initialize": function() {
            this._populateData()
                ._createComponentModel();
            this.get('data').studentResponseScore = 0;
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "textImageComponentModelData": null,
                    "backgroundImageData": null,
                    "teiGUID": null,
                    "teiSide": null,
                    "studentResponseScore": null,
                    "bAddCustomFeedback": null,
                    "sCustomFeedback": null,
                    "userScoreStatus": null,
                    "maxScoreStatus": null,
                    "teiComponentAccText": null,
                    "textImageComponentAccText": null,
                    "globalComponentData": null
                }
            });
        },

        /**
         * Populates the data of the model
         *
         * @method _populateData
         * @return {Object} Instance of model
         * @private
         */
        "_populateData": function() {
            var data = this.get('data');

            if (!data) {
                this.set('data', this.defaults().data);
            }
            if (data && !data.saveState) {
                this.set('data', _.extend(data, this._getSaveStateJSONStructure()));
            }
            return this;
        },

        "_getSaveStateJSONStructure": function() {
            return {
                "saveState": {
                    "studentResponse": {
                        "assessmentGuid": null,
                        "items": []
                    }
                }
            };
        },

        /**
         * Creates the Text Image Component Model
         *
         * @method _createComponentModel
         * @private
         */
        "_createComponentModel": function() {
            this.textImageComponentModel = new TextImageComponentModel(this.get('data').textImageComponentModelData || {});
        },

        "getCurrentStudentScore": function() {
            var saveState = this.get('data').saveState,
                score = 0;

            if (saveState) {
                _.each(saveState.studentResponse.items, function(item) {
                    score += parseInt(item.tries[0].score, 10);
                }, this);
            }
            return score;
        }
    }, {
        "EVENTS": {
            "RETRIEVE_SAVE_STATE": 'retrieve-save-state',
            "GET_SAVE_STATE": 'get-save-state'
        },

        "SIDE": {
            "LEFT": 'left',
            "RIGHT": 'right'
        }
    });

    return HalfWidthModel;
});

